<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Draycott Everlasting</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="application/xhtml+xml; charset=utf-8" http-equiv="content-type"/>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<div class="frontMatterPage" id="fm01"><div class="chapterHead"><h2 class="chapterTitle"> </h2></div><div class="chapterBody"><h2 class="halfTitlePageTitle"><span class="bold"><span><em class="italic"><span>Christmas Knight</span></em></span></span></h2></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// draycotteverlasting_fm01.vue?51c71206